import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { SessionService } from '../../../core/services/session.service';
import { SessionsListActions } from './sessions-list.actions';

@Injectable()
export class SessionsListEffects {
  private readonly actions$ = inject(Actions);
  private readonly sessionService = inject(SessionService);

  readonly loadSessions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SessionsListActions.loadSessions),
      switchMap(({ page, perPage, status }) =>
        this.sessionService.listSessions(page, perPage, status).pipe(
          map((response) => SessionsListActions.loadSessionsSuccess({ response })),
          catchError((error) =>
            of(SessionsListActions.loadSessionsFailure({ error: error.message }))
          )
        )
      )
    )
  );
}
